import React, { useState } from 'react';
import '../styles/_visibility-dropdown.scss';
import { COLOURS } from '../../../../../ui-kit/common/styles/vars';
import { Button, Icon, Link, MenuButton, Text } from '../../../../../ui-kit';











const VisibilityDropdown = (props) => {
  const {
    value,
    allowedWriteVisibilityOptions,
    onChange,
    isShootstaUser,
    organisationName,
    id,
    hideLabel
  } = props;
  const [selectedValue, setSelectedValue] = useState(value);

  const VISIBILITY_OPTIONS = {
    PUBLIC: {
      text: 'Public',
      description: 'Clients, editors and anyone accessing the project can see',
      bgColor: '#E3F4F1',
      textColor: COLOURS.cyan.jungleGreen.monkey,
      iconColor: 'monkey',
      icon: 'activity'
    },
    INTERNAL: {
      text: isShootstaUser ? 'Client Internal' : 'Internal',
      description: `Only ${organisationName} members and collaborators can see`,
      bgColor: '#F8F1D6',
      textColor: COLOURS.grey.grayBrown,
      iconColor: 'grayBrown',
      icon: 'group2'
    },
    SHOOTSTA_INTERNAL: {
      text: 'Shootsta Internal',
      description: 'Only Shootsta members can see (Internal Mode)',
      bgColor: '#F8F1D6',
      textColor: COLOURS.grey.grayBrown,
      iconColor: 'grayBrown',
      icon: 'group2'
    }
  };

  const handleChange = (option) => {
    setSelectedValue(option);
    if (onChange) {
      onChange(option);
    }
  };

  const renderVisibilityDropdown = (option) =>
  <div className="visibility-dropdown-content-wrapper">
      <Link button onClick={() => handleChange(option)}>
        <Icon name={VISIBILITY_OPTIONS[option].icon} size={20} />
        <div className="visibility-dropdown-content">
          <Text noMargin label className="visibility-dropdown-content__title">
            {VISIBILITY_OPTIONS[option].text}
          </Text>
          <Text
          noMargin
          subtitle
          className="visibility-dropdown-content__subtitle">

            {VISIBILITY_OPTIONS[option].description}
          </Text>
        </div>
        {selectedValue === option && <Icon name="success" size={20} />}
      </Link>
    </div>;


  const renderDropdownButton = () =>
  <Button
    style={{
      backgroundColor: VISIBILITY_OPTIONS[selectedValue].bgColor,
      cursor: !onChange && 'unset'
    }}
    prefix={
    <Icon
      name={VISIBILITY_OPTIONS[selectedValue].icon}
      color={VISIBILITY_OPTIONS[selectedValue].iconColor}
      size={16} />}


    className="visibility-dropdown__button"
    type="TERTIARY"
    hasMenuIcon={false}>

      {!hideLabel &&
    <Text
      className="visibility-dropdown__label"
      noMargin
      style={{ color: VISIBILITY_OPTIONS[selectedValue].textColor }}>

          {VISIBILITY_OPTIONS[selectedValue].text}
        </Text>}

      {onChange ?
    <Icon
      name="arrowdown"
      color={VISIBILITY_OPTIONS[selectedValue].iconColor}
      size={10} /> :

    null}
    </Button>;


  return (
    <div className="visibility-dropdown">
      {onChange ?
      <MenuButton
        id={`visibility-dropdown-menu-${id}`}
        fallbackPlacements={['bottom']}
        closeAfterClick
        customButton={renderDropdownButton()}>

          {allowedWriteVisibilityOptions.map((option) => renderVisibilityDropdown(option)
        )}
        </MenuButton> :

      renderDropdownButton()}

    </div>);

};

export default VisibilityDropdown;